import React from "react";

export default class NoIndex extends React.Component {
    render() {
        return (
            <>
                <span dangerouslySetInnerHTML={{ __html: "<!--noindex-->" }} />
                {this.props.children}
                <span dangerouslySetInnerHTML={{ __html: "<!--/noindex-->" }} />
            </>
        );
    }
}
